import { Box, Dialog, IconButton, Stack, styled, Typography } from '../../../base';

export const StyledList = styled(Stack)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1.5),
    overflow: 'hidden',
}));

export const StyledRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minHeight: theme.spacing(6.5),
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    '&:last-of-type': {
        borderBottom: 'none',
    },
    '&:hover': {
        backgroundColor: theme.palette.grey[100],
    },
}));

export const StyledReasonText = styled(Typography)(({ theme }) => ({
    flex: 1,
    color: theme.palette.text.primary,
    unicodeBidi: 'plaintext',
    wordBreak: 'break-word',
}));

export const StyledEmptyState = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(4, 2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        position: 'relative',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
    },
}));

export const StyledDialogCloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    insetInlineEnd: theme.spacing(1),
}));
